import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";
import { MobileNavDrawer } from "./MobileNavDrawer";

// D-044 S5 HOTFIX — ViewAsBanner ПЕРЕНЕСЕНО на root-layout (App.tsx, над
// ProtectedRoute), щоб «Вийти» лишався доступним навіть коли цей шар не
// змонтувався (skeleton/403/crash). Тут — звичайний робочий layout.
//
// D-124 M1 — mobile nav-shell: the Topbar hamburger (<768px) toggles the
// off-canvas MobileNavDrawer (same backend navModel as the desktop Sidebar).
// While open, the page CONTENT (`<main>`) is `inert` so it isn't interactive or
// tabbable; the topbar stays operable so focus can restore to the hamburger on
// close (AC-MOBILE-LOCK + focus-trap in useDrawerA11y).
export function AppLayout() {
  const [navOpen, setNavOpen] = useState(false);
  const mainRef = useRef<HTMLElement | null>(null);
  const location = useLocation();

  // Item-select navigates → close the drawer on route change.
  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  // Background `inert` while open (React 18 has no `inert` prop → toggle via DOM).
  useEffect(() => {
    const el = mainRef.current;
    if (!el) return;
    if (navOpen) el.setAttribute("inert", "");
    else el.removeAttribute("inert");
  }, [navOpen]);

  return (
    <div data-density="comfortable" className="flex h-full bg-background text-foreground">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <Topbar onMenuOpen={() => setNavOpen(true)} menuOpen={navOpen} />
        <main ref={mainRef} className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
      <MobileNavDrawer open={navOpen} onClose={() => setNavOpen(false)} />
    </div>
  );
}
